var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("select", {
    attrs: {
      name: _vm.name,
      id: _vm.name,
      placeholder: _vm.placeholder,
      disabled: _vm.disabled,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }